export const formatPrice = (price: number, locale: string) => {
  if (locale === 'en') return '£' + price;

  return `${price}\u00a0€`;
};
